import { useEffect } from 'react';
import { join } from 'light-component';
import { Input } from 'antd';
import { useTranslation } from '../../../i18n';
import styles from '../style.module.less';
import { service } from '../service';
import { DragItem, Highlighter } from '../../component';
import { Box } from '../../../box';
import type { ReactElement } from 'react';
import type { ShotEyesUserProps } from './types';

export function ShotEyesUserDesignMode(props: ShotEyesUserProps): ReactElement {
  const [t] = useTranslation();
  useEffect(() => {
    if (props.name !== '') {
      props?.onPropsChange?.({ title: t('ShotEyesUser') });
    }
  }, [props.name]);
  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesUser')} />
    );
  }
  return (
    <Box
      className={join(styles.designBox, { [styles.checkActive]: props.active === true })}
      style={{ paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <Input type='text' placeholder={props.textPlaceholder ?? ''} />
      </Box>
    </Box>
  );
}
